import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import TaskTemplateFactory from "../../Entity/Factories/TaskTemplateFactory";
import { TaskTemplateInterface } from "../../Entity/Entities/Task/TaskTemplateInterface";

class TaskTemplateDelete extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const taskTemplate: TaskTemplateInterface = TaskTemplateFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_TASK_TEMPLATE_DELETE_SUCCESS,
      payload: {
        taskTemplate: taskTemplate
      }
    });
  }

}

export { TaskTemplateDelete };
